const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const MARKETING_SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_MARKETING_SITE_URL?.trim() || 'https://glyyd.com'
);
